<mat-dialog-content id="compare-planogram-dialog-content">
    <div class="header">
        <div>
            <span >Add To compare</span>
            <mat-form-field appearance="outline" class="compare-planogram-search-input">
                <mat-icon style="font-size:15px;color:#0B0E1E;opacity:30%;" matPrefix>search</mat-icon>
                <input matInput type="text" [(ngModel)]="search_input" placeholder="Search Planogram"
                    (ngModelChange)="updateFilter()">
                <!-- <em class="bi bi-funnel"></i> -->
            </mat-form-field>
        </div>
        
        <div class="buttons" >
            <button mat-raised-button color="warn" [disabled]="planogram_ids.length < 2" (click)="comparePlanograms()" >
                <em class="bi bi-check-circle-fill"></em>
                Compare Now
            </button>
            <button mat-icon-button class="close-button" disableRipple [mat-dialog-close]="true">
                <mat-icon class="close-icon" >close</mat-icon>
            </button>
        </div>
        
    </div>
  
    <div class="warning" > Note: For Comparison Maximum 3 Planogram will be selected.</div>

    <div style="width: 100%; height: calc(100% - 100px); overflow:auto">
        <!-- <ng-template #mytable let-planograms="data_source" [ngTemplateOutlet]="mytable"
            [ngTemplateOutletContext]="{data_source: getDataSource()}"> -->
        <table id="planogram-list-table" mat-table *ngIf="dataSource.data.length > 0" aria-describedby=""
            [dataSource]="dataSource" #mytable matSort (matSortChange)="announceSortChange($event)"
            class="my-table mat-elevation-z8">

            <!-- Name Column -->
            <ng-container matColumnDef="name">
                <th style="padding-left:2vw;width:14vw" mat-header-cell *matHeaderCellDef mat-sort-header> Name
                </th>
                <td style="padding-left: 30px;text-align: left;" mat-cell *matCellDef="let planogram" class="planogram-name-cell" >
                  <div style="display: flex;">
                    <em [ngClass]="{'bi-check-square text-danger' : planogram_ids.includes(planogram.id) ,
                    'bi-square default-color' : !planogram_ids.includes(planogram.id)}"
                    class="bi" (click)="$event.stopPropagation(); selectPlanogram(planogram.id)" ></em> 
                    <div *ngIf="!showName(planogram.name)" style="display: inline-block;">{{planogram.name}}</div>
                    <div *ngIf="showName(planogram.name)" [matTooltip]="planogram.name" style="display: inline-block;">{{planogram.name.slice(0,17)}}</div>
                 </div>
                </td>
            </ng-container>
           

           
            <ng-container matColumnDef="unit">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Unit </th>
                <td mat-cell *matCellDef="let planogram"> {{planogram.unit}} </td>
            </ng-container>

            
            <ng-container matColumnDef="channel">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Channel </th>
                <td mat-cell *matCellDef="let planogram">
                    {{planogram.channel}} </td>
            </ng-container>

            
            <ng-container matColumnDef="cooler_type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Cooler Type </th>
                <td mat-cell *matCellDef="let planogram"> {{planogram.cooler_type}} </td>
            </ng-container>
            <ng-container matColumnDef="cooler_value">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> On Turn Value </th>
                <td mat-cell  *matCellDef="let planogram"> ₹ {{planogram.cooler_value}} </td>
            </ng-container>
            <ng-container matColumnDef="created_at">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Created On </th>
                <td mat-cell *matCellDef="let planogram"> {{planogram.created_at}} </td>
            </ng-container>
            <ng-container *ngIf="isAdminFlagInComparable==1" matColumnDef="created_by">
                <th mat-header-cell *matHeaderCellDef>
                    Created By
                 </th>
                <td mat-cell *matCellDef="let planogram"> {{planogram.created_by}} </td>
            </ng-container>
            <!-- Business Goals Column -->
            <ng-container matColumnDef="progress_status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
                <td mat-cell *matCellDef="let planogram">
                    <span class="planogram-status" [ngClass]="{'active' : planogram.progress_status === CONFIG.PLANOGRAMSTATUS.ACTIVE,
                            'inactive': planogram.progress_status === CONFIG.PLANOGRAMSTATUS.INACTIVE, 
                         'draft': planogram.progress_status === CONFIG.PLANOGRAMSTATUS.DRAFT}">
                        {{planogram.progress_status}}
                    </span>
                </td>
            </ng-container>

            <!-- (click)="handleRowClick(row)" -->
            <tr mat-header-row *matHeaderRowDef="isAdminFlagInComparable==1?displayedColumnsForAdmin:displayedColumnsForUser"></tr>
            <tr mat-row *matRowDef="let row; columns: isAdminFlagInComparable==1?displayedColumnsForAdmin:displayedColumnsForUser;" (click)="selectPlanogram(row.id)" ></tr>

            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="6">No data matching with the filter</td>
            </tr>

        </table>
    </div>

    <app-loader [is_show_loader]="(is_show_loader | async)!" ></app-loader>

</mat-dialog-content>